<template>
  <div class="elUploadsChoice">
    <el-upload :multiple="multiple" :on-success="onSuccess" :on-error="onError" :headers="{ token: token }"
      :disabled="!(!upLoad.uploadProgress || upLoad.uploadProgress >= 100)" ref="upload" class="upload-demos"
      :on-progress="onProgress" :before-upload="beforeUpload" :show-file-list="false"
      :action="uploadUrl">
      <div class="el-upload__text">
        <slot name="upButton">点击上传文件或拖拽</slot>
      </div>
    </el-upload>
    <el-dialog @close="closeDialog" top="25vh" :visible.sync="dialogTableVisible" :destroy-on-close="true"
      :close-on-press-escape="false" :close-on-click-modal="false" :show-close="false">
      <div style="margin-bottom: 20px;" v-for="(item, index) in upLoad.fileList" :key="`${index}a`">
        <template v-if="item.show">
          <div class="upBox">
            <div class="leftUpBox">
              <h3>等待文件传输</h3>
              <p style="margin-bottom: 15px;">在文件传输过程中，不可进行其他操作，请等待文件传输完成。</p>
            </div>
            <div class="rightUpBox">
              <p class="speed">
                <svg-icon style="width:18px;height: 14px;" icon-class="wifi"></svg-icon>
                传输速度 <span class="green">{{ item.speed }}</span>
              </p>
              <p class="surplus">
                <i class="el-icon-time" style="font-size: 18px;"></i>
                预计剩余 <span class="red">{{ item.remainingTime }}</span>
              </p>
            </div>
          </div>
          <div class="flexNormal btnGrop">
            <div class="transBTn flexNormal" @click.stop="cancelUpload(item)">取消上传</div>
            <div class="blueBTn flexNormal">
              <el-progress text-color="#fff" :text-inside="true" :stroke-width="31.5"
                :percentage="Number(item.progress)"></el-progress>
            </div>
            <p>{{ item.uploadedSize }} / {{ item.totalSize }}</p>
          </div>
        </template>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'elUploadsChoice',
  data() {
    return {
      dialogTableVisible: false,
      token: sessionStorage.getItem(`${this.alias}token`),
      uploading: false,
      startTime: 0,
      currentTime: 0,
      upLoad: {
        fileList: [], // 上传内容
        data: [], // 后台上传成功后返回的数据
      },
      uploadUrl: `${process.env.BASE_URL}api/file/upload`,
    };
  },
  props:{
    multiple: {
      type: Boolean,
      default: true
    },
  },
  created() { },
  mounted() { },
  methods: {
    // 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeUpload(file, fileList) {
      this.upLoad.file = file;
      this.$set(this.upLoad.file, 'sizeNUm', (file.size / 1024).toFixed(1))
      let isLt0M = file.size > 1;
      if (!isLt0M) {
        this.upLoad.file = null;
        this.$message({ message: "请上传正确的文件大小", type: "error" });
        return false;
      }
      this.dialogTableVisible = true;
    },
    // 文件上传时的钩子
    onProgress(event, file, fileList) {
      if (!this.uploading) {
        this.startTime = new Date().getTime();
        this.uploading = true;
      }
      this.currentTime = new Date().getTime();
      let progress = Math.floor((event.percent))
      if (progress >= 100) progress = 95;
      this.$set(file, "progress", progress)
      this.$set(file, "speed", this.calculateSpeed(event.loaded, file))
      this.$set(file, "remainingTime", this.calculateRemainingTime(event.percent, file))
      this.$set(file, "uploadedSize", this.formatSize(event.loaded))
      this.$set(file, "totalSize", this.formatSize(event.total))
      this.$set(file, "show", true)
      this.upLoad.fileList = fileList
    },

    // onSuccess
    onSuccess(res, file, fileList) {
      this.$set(file, "progress", 100)
      this.$message({ message: `${file.name}上传成功`, type: "success" });
      setTimeout(() => {
        this.$set(file, "show", false)
        const allShouFalse = this.upLoad.fileList.every(item => item.show == false);
        if (allShouFalse) this.dialogTableVisible = false;
        this.$emit("success", file);
      }, 1500);
    },
    onError(err, file, fileList) {
      this.$message({ message: `${file.name}上传失败，${err.data.msg}`, type: "error" });
    },
    // 取消上传
    cancelUpload(item) {
      this.$refs.upload.abort(item.raw);
      this.$message({ message: `${item.name}已取消上传`, type: "warning" });
      setTimeout(() => {
        this.$set(item, "show", false);
        const allShouFalse = this.upLoad.fileList.every(item => item.show == false);
        if (allShouFalse) this.dialogTableVisible = false;
      }, 1500);
    },
    // 关闭弹窗
    closeDialog() {
      this.upLoad.file = [];
      this.upLoad.data = [];
    },
    /**
     * 一些方法
     */
    calculateSpeed(loaded, file) {
      const elapsed = (this.currentTime - this.startTime) / 1000;
      const speed = loaded / elapsed;
      return this.formatSpeed(speed);
    },
    calculateRemainingTime(percent, file) {
      const remainingBytes = 100 - percent;
      const speedNumeric = parseFloat(file.speed.replace(/[^\d.]/g, ''));
      if (isNaN(speedNumeric) || speedNumeric === 0) {
        return '计算中';
      }
      const elapsed = (this.currentTime - this.startTime) / 1000;
      const remainingTime = (remainingBytes / speedNumeric) * elapsed;
      return this.formatTime(remainingTime);
    },
    formatSpeed(speed) {
      if (speed < 1024) {
        return speed.toFixed(2) + ' B/s';
      } else if (speed < 1024 * 1024) {
        return (speed / 1024).toFixed(2) + ' KB/s';
      } else {
        return (speed / (1024 * 1024)).toFixed(2) + ' MB/s';
      }
    },
    formatSize(size) {
      if (size < 1024) {
        return size.toFixed(2) + ' B';
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB';
      } else {
        return (size / (1024 * 1024)).toFixed(2) + ' MB';
      }
    },
    formatTime(seconds) {
      if (seconds < 60) {
        return seconds.toFixed(0) + ' s';
      } else if (seconds < 3600) {
        return (seconds / 60).toFixed(0) + ' min';
      } else {
        return (seconds / 3600).toFixed(2) + ' h';
      }
    },
    resetUploadState() {
      this.uploading = false;
      this.upLoad.fileList = [];
      this.startTime = 0;
      this.currentTime = 0;
    }
  }
};
</script>
<style lang='less' scoped>
// .upload-demos{

// }
/deep/ .el-dialog {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 85%;
  max-width: 700px;
  background-color: transparent;
  box-shadow: none;
  border-radius: 10px;
  user-select: none;
  margin: 10px;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;


    .upBox {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      color: #fff;
      padding: 15px 20px;
      padding-bottom: 0;
      box-sizing: border-box;
      border-radius: 10px 10px 0 0;
      background-color: @theme_color;

      .leftUpBox {
        p {
          margin-top: 4px;
          color: #9CA3AF;
        }
      }

      .rightUpBox {
        .surplus {
          margin-top: 10px;
        }
      }

    }
  }
}

/deep/ .el-dialog__wrapper {
  background: rgba(55, 65, 81, 0.50);

}


.btnGrop {
  justify-content: flex-start !important;
  padding: 0 25px;
  border-radius: 0px 0px 10px 10px;
  padding-bottom: 15px;
  background-color: @theme_color;
}

.transBTn,
.blueBTn {
  width: 100px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid @status_blue;
  background: rgba(62, 123, 250, 0.50);
  // background: @status_blue;
  font-weight: 500;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
}

.transBTn {
  background-color: #0000006f;
  border-color: transparent;
  margin-right: 15px;
}

.el-progress {
  width: 100%;

  /deep/.el-progress-bar__outer {
    border-radius: 0;
    background-color: transparent !important;
  }

  /deep/ .el-progress-bar__inner {
    border-radius: 0;
  }
}
</style>
<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  .upload-demos {
    height: 32px;
  }

  /deep/ .el-dialog {
    width: 100%;
    max-width: 100%;

    .el-dialog__body {
      .upBox {
        flex-direction: column;

        .rightUpBox {
          .surplus {
            margin: 10px 0;
          }
        }
      }
    }
  }
}
</style>